export const FETCH_INITIAL_HISTORY = 'FETCH_INITIAL_HISTORY';
export const FETCHING_INITIAL_HISTORY = 'FETCHING_INITIAL_HISTORY';
export const INITIAL_HISTORY_LOAD_SUCCESSFUL = 'INITIAL_HISTORY_LOAD_SUCCESSFUL';
export const FETCH_NEXT_NOTIFICATION_PAGE = 'FETCH_NEXT_NOTIFICATION_PAGE';
export const REMOVE_NOTIFICATION_FROM_HISTORY = 'REMOVE_NOTIFICATION_FROM_HISTORY';
export const REMOVE_RED_DOT_BELL_ICON = 'REMOVE_RED_DOT_BELL_ICON';
export const GOT_NEW_NOTIFICATION_HISTORY = 'GOT_NEW_NOTIFICATION_HISTORY';
